import React from 'react';
import { Button, PressEvent } from "@heroui/react";
import { FaHeart, FaRegHeart } from 'react-icons/fa';
import { usePlaceFollowing } from '../../../hooks/usePlaceFollowing';
import { useAuthModal } from '../../../hooks/useAuthModal';
import { useEvent } from '~/hooks/useEvent';
interface PlaceFollowButtonProps {
  placeId: string;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export const PlaceFollowButton: React.FC<PlaceFollowButtonProps> = ({ placeId, className, size = 'md' }) => {
  const {
    isFollowing,
    followPlace,
    unfollowPlace,
    isLoading,
  } = usePlaceFollowing(placeId);
  const { requireAuth, isAuthenticated } = useAuthModal();
  const { sendEvent } = useEvent();

  const handleClick = (e: PressEvent) => {

    e.continuePropagation();

    if (isFollowing) {
      sendEvent('place_follow_button_click', {
        placeId,
        isFollowing: true,
        isAuthenticated: isAuthenticated,
      });
      requireAuth(() => unfollowPlace());
    } else {
      sendEvent('place_follow_button_click', {
        placeId,
        isFollowing: false,
        isAuthenticated: isAuthenticated,
      });
      requireAuth(() => followPlace());
    }
  };

  return (
    <Button
      isIconOnly
      variant={isFollowing ? 'solid' : 'bordered'}
      color={isFollowing ? 'primary' : 'default'}
      onPress={handleClick}
      isLoading={isLoading}
      className={className}
      aria-label={isFollowing ? 'Unfollow' : 'Follow'}
      size={size}
    >
      {isFollowing ? <FaHeart /> : <FaRegHeart />}
    </Button>
  );
}; 